import { render, staticRenderFns } from "./mchNo-Config.vue?vue&type=template&id=5ae36b28&scoped=true&"
import script from "./mchNo-Config.vue?vue&type=script&lang=js&"
export * from "./mchNo-Config.vue?vue&type=script&lang=js&"
import style0 from "./mchNo-Config.vue?vue&type=style&index=0&id=5ae36b28&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae36b28",
  null
  
)

export default component.exports